/*
 * BN custom scripts (not part of the theme vendor code).
 * Loaded from layout/theme.liquid. Keep BN-only JS here so theme upgrades don't wipe it.
 */
// Finish The Look button: scroll to Material Set section instead of switching tabs
document.addEventListener(
  'click',
  function (event) {
    const finishLookButton = event.target.closest('[data-tab="tab-5"]');

    if (!finishLookButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const target = Array.from(
      document.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, div')
    ).find((element) => element.textContent.trim() === 'Material Set');

    if (target) {
      const headerOffset = 120;
      const targetTop =
        target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    }
  },
  true
);
